let userService = {
  getCookie(name) {
    let value = '; ' + document.cookie
    let parts = value.split('; ' + name + '=')
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift()
  },
  getUserName() {
    let cookie = this.getCookie('userInfo')
    if (cookie) {
      return JSON.parse(decodeURIComponent(cookie)).name || ''
    } else {
      return ''
    }
  },
  getUserEmail() {
    let cookie = this.getCookie('userInfo')
    if (cookie) {
      return JSON.parse(decodeURIComponent(cookie)).email || ''
    } else {
      return ''
    }
  },
  getUserToken() {
    let cookie = this.getCookie('userInfo')
    if (cookie) {
      return JSON.parse(decodeURIComponent(cookie)).accessToken || ''
    } else {
      return ''
    }
  },
  getUserId() {
    let cookie = this.getCookie('userInfo')
    if (cookie) {
      return JSON.parse(decodeURIComponent(cookie)).userId || ''
    } else {
      return ''
    }
  },
  isLoggedIn() {
    return !!this.getUserId()
  },
  isInternalUser() {
    if (!this.isLoggedIn()) {
      return false
    }

    const cookie = this.getCookie('userInfo') || ''
    const userEmail = this.getUserEmail()
    const roles = JSON.parse(decodeURIComponent(cookie)).roles || []

    if (roles.includes('admin')) {
      return true
    }

    if (
      /@asokoinsight.com\s*$/.test(userEmail) &&
      !roles.includes('customer')
    ) {
      return true
    }

    return false
  },
  getUserCohort() {
    if (!this.isLoggedIn()) {
      return 'anonymous'
    }

    let cookie = this.getCookie('userInfo')
    if (cookie) {
      return JSON.parse(decodeURIComponent(cookie)).cohort || ''
    } else {
      return ''
    }
  },
  setAnalyticsAsInternalUser(internal = true) {
    const cookieValue = internal ? 'internal' : '' // to (re)enable analytics, just delete the cookie by setting its value to nothing
    const expirationYear = internal ? '9999' : '1970'
    document.cookie = `internal=${cookieValue};expires='Fri, 31 Dec ${expirationYear} 23:59:59 GMT';path=/`
  },
  isAnalyticsAsInternalUser() {
    let cookie = this.getCookie('internal')
    if (cookie === 'internal') {
      return true
    }
    return false
  },
}

export default userService
